import React from 'react';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
import { WhatsAppButton } from './WhatsAppButton';
import { Instagram, Facebook, Calendar } from 'lucide-react';
const EXPERIENCES = [{
  title: "Men's Sauna Nights",
  desc: 'Heat, cold, and brotherhood. A space to drop the armor and just be.',
  img: 'https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg'
}, {
  title: 'Breathwork Circles',
  desc: 'Guided journeys to move energy, release tension, and find stillness.',
  img: 'https://cdn.magicpatterns.com/uploads/8jw5SDRb5f5nVzkkgx9KD2/470562478_122128866854570946_8321049361434838301_n.jpg'
}, {
  title: 'Ice Bath Workshops',
  desc: 'Step into the cold. Find the breath. Walk out clearer than you came in.',
  img: 'https://cdn.magicpatterns.com/uploads/2R6iFsj5APGTGwRYAVkiFK/470801593_122128867442570946_8740882224121444447_n.jpg'
}, {
  title: 'Music Gatherings',
  desc: 'Acoustic circles, singing, and connection inside the dome or around the fire.',
  img: 'https://cdn.magicpatterns.com/uploads/hffDynZX3nXn2CNTPNVY6M/471428511_122131322642570946_6342459253165615123_n.jpg'
}, {
  title: 'Private Retreats',
  desc: 'Bring your own group. We provide the space, the heat, and the atmosphere.',
  img: 'https://cdn.magicpatterns.com/uploads/tCCtuiYevJjrLRPGX4h7mj/470823327_122128867136570946_1434913759190205541_n.jpg'
}, {
  title: 'Overnight Stays',
  desc: 'Stay on the land. Wake slowly. Keep the reset going past the night before.',
  img: 'https://a0.muscache.com/im/pictures/hosting/Hosting-42704474/original/fe32518c-f3bb-4193-8ba1-f8c45b2af0e0.jpeg?im_w=1440'
}];
export function WhatHappensHere() {
  return <section id="experiences" className="py-20 md:py-32 px-6 md:px-12 bg-creamDeep relative scroll-mt-16" data-id="element-260">
      <div className="max-w-6xl mx-auto" data-id="element-261">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-262">
          <FadeIn data-id="element-263">
            <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-264">
              Events & Experiences
            </p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-265">
            <h2 className="font-serif text-4xl md:text-5xl text-pine mb-6" data-id="element-266">
              Bring your gathering to the land.
            </h2>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-267">
            <p className="text-lg text-clay font-light leading-relaxed" data-id="element-268">
              These are the kinds of events the space holds — and the kinds we'd
              love to help you plan. Schedule any of them, or bring your own
              vision. Reach out and Zev will walk you through what's possible.
            </p>
          </FadeIn>
        </div>

        {/* Experience cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-16 md:mb-24" data-id="element-269">
          {EXPERIENCES.map((exp, idx) => <FadeIn key={exp.title} delay={idx * 0.08} className="group cursor-default" data-id="element-270">
              <div className="relative h-80 md:h-96 w-full overflow-hidden rounded-sm" data-id="element-271">
                <img src={exp.img} alt={exp.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-272" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/40 to-transparent opacity-90" data-id="element-273" />

                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8" data-id="element-274">
                  <h3 className="font-serif text-2xl text-cream mb-3" data-id="element-275">
                    {exp.title}
                  </h3>
                  <p className="text-sand/90 font-light leading-relaxed text-sm" data-id="element-276">
                    {exp.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Schedule-an-event CTA */}
        <FadeIn className="text-center mb-24 md:mb-32" data-id="element-277">
          <p className="text-clay/80 mb-6 font-light text-lg max-w-xl mx-auto" data-id="element-278">
            Planning a workshop, retreat, sauna night, or private gathering?
          </p>
          <div className="flex justify-center" data-id="element-279">
            <WhatsAppButton label="Tell Zev what you're planning" data-id="element-280" />
          </div>
        </FadeIn>

        {/* Upcoming events placeholder */}
        <div className="border-t border-pine/10 pt-16 md:pt-20" data-id="element-281">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-282">
            <div data-id="element-283">
              <FadeIn data-id="element-284">
                <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-285">
                  Upcoming Public Events
                </p>
              </FadeIn>
              <FadeIn delay={0.1} data-id="element-286">
                <h3 className="font-serif text-3xl md:text-4xl text-pine mb-6 leading-tight" data-id="element-287">
                  What's coming up on the land.
                </h3>
              </FadeIn>
              <FadeIn delay={0.2} data-id="element-288">
                <p className="text-clay font-light leading-relaxed mb-8" data-id="element-289">
                  Public sauna nights, workshops, and gatherings are posted
                  first on Instagram and Facebook. Direct event listings are
                  coming soon — for now, follow along or message Zev to get on
                  the list for the next one.
                </p>
              </FadeIn>

              <FadeIn delay={0.3} className="flex flex-col sm:flex-row gap-3" data-id="element-290">
                <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-pine text-cream rounded-sm font-medium tracking-wide hover:bg-pineDeep transition-colors" data-id="element-291">
                  <Instagram className="w-4 h-4" data-id="element-292" />
                  Follow on Instagram
                </a>
                <a href={LINKS.facebook} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-transparent border border-pine/25 text-pine rounded-sm font-medium tracking-wide hover:bg-pine/5 hover:border-pine/40 transition-colors" data-id="element-293">
                  <Facebook className="w-4 h-4" data-id="element-294" />
                  Facebook
                </a>
              </FadeIn>
            </div>

            {/* Placeholder event cards */}
            <FadeIn delay={0.2} data-id="element-295">
              <div className="space-y-3" data-id="element-296">
                {[1, 2, 3].map(i => <div key={i} className="flex items-center gap-4 p-5 bg-cream border border-pine/15 border-dashed rounded-sm" data-id="element-297">
                    <div className="w-12 h-12 rounded-sm bg-creamDeep flex items-center justify-center flex-shrink-0" data-id="element-298">
                      <Calendar className="w-5 h-5 text-pine/40" data-id="element-299" />
                    </div>
                    <div className="flex-1" data-id="element-300">
                      <div className="h-3 w-24 bg-pine/10 rounded-full mb-2" data-id="element-301" />
                      <div className="h-2 w-40 bg-pine/10 rounded-full" data-id="element-302" />
                    </div>
                    <span className="text-xs text-clay/50 uppercase tracking-widest" data-id="element-303">
                      TBD
                    </span>
                  </div>)}
                <p className="text-xs text-clay/60 text-center pt-3 italic" data-id="element-304">
                  Live event listings coming soon
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}